export interface TicketInterface {
  id: number;
  type: string;
  title: string;
  dateStart: string;
  dateEnd: string;
  freeCancel: boolean;
  price: {
    [key: string]: number;
  };
  isPickUp: boolean;
  isMeeting: boolean;
  meetingPlaceList: { name: string }[];
}

export class ResponseTicket {
  iata_code: string;

  name: string;

  constructor(data: any) {
    this.iata_code = data.iata_code || "";
    this.name = data.name || "";
  }
}
